<div class="modal-component small">
    <div class="modal-header-content">
        <div class="header-text-container">
            <div class="header-text text-canna-secondary!">
                Neuer Bestätigungslink
            </div>
        </div>
        <button class="modal-close-button" type="button" (click)="onClose()">
            <i class="fa-solid fa-times icon-center"></i>
        </button>
    </div>
    <div class="modal-body-container flex justify-center gap-4">
        <div class="text-center text-xl self-center text-preorder-background-top">
            Falls Sie keinen Bestätigungslink erhalten haben, können Sie sich hier einen neuen zukommen lassen.
        </div>
        <div class="form-group">
            <div class="form-control">
                <input matInput [formControl]="mailFormControl" placeholder="E-Mail Adresse eintragen" class="!bg-white">
            </div>
        </div>
    </div>
    <div class="modal-button-container">
        <button class="btn-tertiary bg-black" (click)="onClose()">Abbrechen</button>
        <button class="btn-primary" (click)="resendLink()">Link senden</button>
    </div>
</div>
